// Items, slots, rarities, affixes. See docs/04-equipment-craft.
export const SLOTS = [
    'weaponMain',
    'offHand',
    'head',
    'chest',
    'hands',
    'boots',
    'belt',
    'amulet',
    'ring1',
    'ring2',
    'cloak',
];
export const RARITIES = ['normal', 'magic', 'rare', 'unique', 'set'];
//# sourceMappingURL=items.js.map